import React, { useState } from 'react'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import DepartmentToolbar from './components/DepartmentToolbar'
import DepartmentListing from './components/DepartmentListing'
import Functions from '../../../../setup/utilities/Functions'

const departmentBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Gestion des employés',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DepartmentWrapper: React.FC = () => {
  const intl = useIntl()
  const [department, setDepartment] = useState<IDepartment|undefined|null>(null)
  const [action, setAction] = useState<string>('')
  const [show, setShow] = React.useState(false)
  const handleClose = async (isSubmit: boolean) => {
    if (!isSubmit) {
      const isConfirmed = await Functions.sweetAlert(
        '<span class="mt-5">Are you sure you would like to cancel</span>',
        'warning',
        true,
        'Yes, cancel it!',
        'No, return',
        'btn btn-primary mt-10 mb-10',
        'btn btn-active-light mt-10 mb-10',
      )
      if (isConfirmed) {
        setShow(false)
      }
    } else {
      setShow(false)
    }
  }
  const handleShow = (department: IDepartment|undefined|null, action: string) => {
    setDepartment(department)
    setAction(action)
    setShow(true)
  }
  return (
    <>
      <PageTitle breadcrumbs={departmentBreadCrumbs} pageTitle={intl.formatMessage({ id: 'department.list' })}>
        <DepartmentToolbar handleShow={handleShow}/>
      </PageTitle>
      <DepartmentListing show={show} handleShow={handleShow} handleClose={handleClose} departmentSelected={department} action={action}/>
    </>
  )
}

export default DepartmentWrapper
